export let ResellerCertificateStatuses = /*#__PURE__*/function (ResellerCertificateStatuses) {
  ResellerCertificateStatuses["ALL"] = "ALL";
  ResellerCertificateStatuses["PENDING"] = "PENDING";
  ResellerCertificateStatuses["APPROVED"] = "APPROVED";
  ResellerCertificateStatuses["REJECTED"] = "REJECTED";
  return ResellerCertificateStatuses;
}({});